import { render } from "./ReservePage.vue?vue&type=template&id=45be52bf&scoped=true"
import script from "./ReservePage.vue?vue&type=script&lang=js"
export * from "./ReservePage.vue?vue&type=script&lang=js"

import "./ReservePage.vue?vue&type=style&index=0&id=45be52bf&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45be52bf"]])

export default __exports__